import { SVGProps } from 'react';
import { SvgProps } from './ic_portfolio';
/* SVGR has dropped some elements not supported by react-native-svg: title */
export const SvgList = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={24}
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        className="lucide lucide-list-icon lucide-list text-white"
    >
        <path d="M3 12h.01M3 18h.01M3 6h.01M8 12h13M8 18h13M8 6h13" />
    </svg>
);
export const SvgGrid = (props: SvgProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={24}
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        className="lucide lucide-grid2x2-icon lucide-grid-2x2 text-white"
        {...props}
    >
        <path d="M12 3v18M3 12h18" />
        <rect width={18} height={18} x={3} y={3} rx={2} />
    </svg>
);

export const SvgBack = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <g clip-path="url(#clip0_1822_4745)">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.91049 10.5893C6.75427 10.433 6.6665 10.2211 6.6665 10.0001C6.6665 9.77915 6.75427 9.56723 6.91049 9.41096L11.6247 4.69679C11.7015 4.6172 11.7935 4.55371 11.8952 4.51004C11.9968 4.46636 12.1062 4.44338 12.2168 4.44241C12.3275 4.44145 12.4372 4.46254 12.5396 4.50444C12.642 4.54634 12.7351 4.60822 12.8133 4.68646C12.8916 4.7647 12.9534 4.85775 12.9953 4.96016C13.0372 5.06257 13.0583 5.17231 13.0574 5.28296C13.0564 5.39361 13.0334 5.50296 12.9897 5.60463C12.9461 5.7063 12.8826 5.79825 12.803 5.87512L8.67799 10.0001L12.803 14.1251C12.9548 14.2823 13.0388 14.4928 13.0369 14.7113C13.035 14.9298 12.9473 15.1388 12.7928 15.2933C12.6383 15.4478 12.4293 15.5355 12.2108 15.5374C11.9923 15.5393 11.7818 15.4553 11.6247 15.3035L6.91049 10.5893Z"
                fill="white"
            />
        </g>
        <defs>
            <clipPath id="clip0_1822_4745">
                <rect width="20" height="20" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export const SvgChart = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={25}
        fill="none"
        {...props}
    >
        <path
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M7.75 21.619v-3.5"
        />
        <path
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M8.515 18.119H6.984c-.82 0-1.484-.662-1.484-1.48v-6.042a1.48 1.48 0 0 1 1.484-1.478h1.531c.82 0 1.485.66 1.485 1.478v6.043c0 .817-.665 1.479-1.485 1.479Z"
            clipRule="evenodd"
        />
        <path
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M7.75 9.119v-3.5M17.25 19.619v-3.5"
        />
        <path
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M18.015 16.119h-1.531c-.82 0-1.484-.662-1.484-1.48V8.598a1.48 1.48 0 0 1 1.484-1.478h1.531c.82 0 1.485.66 1.485 1.478v6.043c0 .817-.665 1.479-1.485 1.479Z"
            clipRule="evenodd"
        />
        <path
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M17.25 7.119v-3.5"
        />
    </svg>
);

export const SvgChartActive = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={24}
        fill="none"
        {...props}
    >
        <path
            fill="#fff"
            fillRule="evenodd"
            d="M8.308 6.98h-.342V3a.75.75 0 1 0-1.5 0v3.98h-.343c-1.16 0-2.104.947-2.104 2.11v7.72c0 1.159.944 2.1 2.104 2.1h.343V21a.75.75 0 0 0 1.5 0v-2.09h.342c1.16 0 2.104-.941 2.104-2.1V9.09a2.109 2.109 0 0 0-2.104-2.11ZM18.877 5.55h-.342V3a.75.75 0 0 0-1.5 0v2.55h-.343c-1.16 0-2.103.946-2.103 2.11v5.56c0 1.158.943 2.101 2.103 2.101h.343V21a.75.75 0 0 0 1.5 0v-5.679h.342c1.16 0 2.104-.943 2.104-2.101V7.66a2.11 2.11 0 0 0-2.104-2.11Z"
            clipRule="evenodd"
        />
    </svg>
);

export const SvgClose24 = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={24}
        fill="none"
        {...props}
    >
        <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="m6 6 12 12M18 6 6 18"
        />
    </svg>
);

export const SvgSwap = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={16}
        height={16}
        fill="none"
        {...props}
    >
        <g clipPath="url(#a)">
            <path
                fill="#B2B2B2"
                d="M13.69 5.415a.733.733 0 0 1-.44 1.248l-.077.004H2.667a.667.667 0 0 1-.078-1.329l.078-.005h9.057l-1.529-1.528a.667.667 0 0 1 .88-.998l.063.055 2.553 2.553ZM14 10a.667.667 0 0 1-.589.662l-.078.005H4.276l1.529 1.528a.667.667 0 0 1-.88.998l-.063-.055-2.553-2.553a.733.733 0 0 1 .442-1.248l.076-.004h10.506A.667.667 0 0 1 14 10Z"
            />
        </g>
        <defs>
            <clipPath id="a">
                <path fill="#fff" d="M16 0v16H0V0z" />
            </clipPath>
        </defs>
    </svg>
);

export const SvgVolumeIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={16}
        height={16}
        fill="none"
        {...props}
    >
        <path
            fill="#001C03"
            stroke="#2F0"
            strokeWidth={0.353}
            d="m7.705 1.66 6.42 6.42-6.42 6.421-6.42-6.42z"
        />
        <path
            fill="#2F0"
            d="m7.705 4.87 3.21 3.21-3.21 3.21-3.21-3.21zM13.965 6.636l1.284 1.284-1.284 1.284L12.68 7.92zM7.544 13.057l1.284 1.284-1.284 1.284L6.26 14.34zM7.705.375 8.99 1.66 7.705 2.943 6.421 1.66zM1.284 6.796 2.568 8.08 1.284 9.364 0 8.08z"
        />
    </svg>
);

export const SvgVolumeIcon22 = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={22}
        height={22}
        fill="none"
        {...props}
    >
        <path
            fill="#001C03"
            stroke="#2F0"
            strokeWidth={0.5}
            d="m10.91 1.819 9.094 9.093-9.093 9.092-9.093-9.092z"
        />
        <path
            fill="#2F0"
            d="m10.91 6.365 4.547 4.546-4.546 4.546-4.546-4.546zM19.776 8.865l1.819 1.818-1.819 1.82-1.818-1.82zM10.684 17.958l1.819 1.819-1.819 1.818-1.819-1.818zM10.911 0l1.819 1.819-1.819 1.818L9.092 1.82zM1.818 9.093l1.819 1.818-1.82 1.819L0 10.911z"
        />
    </svg>
);

export const SvgVolumeIconUnActive = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
    >
        <rect
            x="10.9111"
            y="1.81885"
            width="12.8589"
            height="12.8589"
            transform="rotate(45 10.9111 1.81885)"
            fill="#141414"
            stroke="#5A5A5A"
            stroke-width="0.5"
        />
        <rect
            x="10.9111"
            y="6.36475"
            width="6.42946"
            height="6.42946"
            transform="rotate(45 10.9111 6.36475)"
            fill="#5A5A5A"
        />
        <rect
            x="19.7764"
            y="8.86523"
            width="2.57178"
            height="2.57178"
            transform="rotate(45 19.7764 8.86523)"
            fill="#5A5A5A"
        />
        <rect
            x="10.6841"
            y="17.958"
            width="2.57178"
            height="2.57178"
            transform="rotate(45 10.6841 17.958)"
            fill="#5A5A5A"
        />
        <rect
            x="10.9111"
            width="2.57178"
            height="2.57178"
            transform="rotate(45 10.9111 0)"
            fill="#5A5A5A"
        />
        <rect
            x="1.81836"
            y="9.09277"
            width="2.57178"
            height="2.57178"
            transform="rotate(45 1.81836 9.09277)"
            fill="#5A5A5A"
        />
    </svg>
);
export const SvgArrow2 = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={21}
        height={20}
        fill="none"
        {...props}
    >
        <path
            fill="#494949"
            d="m16.47 10-5.172-5.172-1.179 1.178L14.114 10l-3.995 3.994 1.179 1.179L16.47 10Zm-4.708 0L6.59 4.828 5.41 6.006 9.405 10l-3.994 3.994 1.179 1.179L11.762 10Z"
        />
    </svg>
);

export const SvgReward2 = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={18}
        height={18}
        fill="none"
        {...props}
    >
        <g clipPath="url(#a)">
            <path
                fill="#fff"
                fillRule="evenodd"
                d="M15 9.75v3.75a2.25 2.25 0 0 1-2.25 2.25h-3v-6H15Zm-6.75 0v6h-3A2.25 2.25 0 0 1 3 13.5V9.75h5.25ZM6.75 1.5A2.993 2.993 0 0 1 9 2.515 2.993 2.993 0 0 1 11.25 1.5h.375a1.125 1.125 0 0 1 1.125 1.125V3c0 .547-.146 1.059-.401 1.5h1.901a1.5 1.5 0 0 1 1.5 1.5v1.5c0 .273-.073.53-.201.75H9.75V6a.75.75 0 0 0-1.5 0v2.25H2.451a1.492 1.492 0 0 1-.201-.75V6a1.5 1.5 0 0 1 1.5-1.5h1.901A2.987 2.987 0 0 1 5.25 3v-.375A1.125 1.125 0 0 1 6.375 1.5h.375Zm0 1.5a1.5 1.5 0 0 0 1.5 1.5A1.5 1.5 0 0 0 6.75 3Zm4.5 0a1.5 1.5 0 0 0-1.5 1.5 1.5 1.5 0 0 0 1.5-1.5Z"
                clipRule="evenodd"
            />
        </g>
        <defs>
            <clipPath id="a">
                <path fill="#fff" d="M0 0h18v18H0z" />
            </clipPath>
        </defs>
    </svg>
);

// export function SvgBack() {
//     return (
//         <svg
//             xmlns="http://www.w3.org/2000/svg"
//             width="20"
//             height="20"
//             viewBox="0 0 20 20"
//             fill="none"
//         >
//             <g clip-path="url(#clip0_1822_4745)">
//                 <path
//                     fill-rule="evenodd"
//                     clip-rule="evenodd"
//                     d="M6.91049 10.5893C6.75427 10.433 6.6665 10.2211 6.6665 10.0001C6.6665 9.77915 6.75427 9.56723 6.91049 9.41096L11.6247 4.69679C11.7015 4.6172 11.7935 4.55371 11.8952 4.51004C11.9968 4.46636 12.1062 4.44338 12.2168 4.44241C12.3275 4.44145 12.4372 4.46254 12.5396 4.50444C12.642 4.54634 12.7351 4.60822 12.8133 4.68646C12.8916 4.7647 12.9534 4.85775 12.9953 4.96016C13.0372 5.06257 13.0583 5.17231 13.0574 5.28296C13.0564 5.39361 13.0334 5.50296 12.9897 5.60463C12.9461 5.7063 12.8826 5.79825 12.803 5.87512L8.67799 10.0001L12.803 14.1251C12.9548 14.2823 13.0388 14.4928 13.0369 14.7113C13.035 14.9298 12.9473 15.1388 12.7928 15.2933C12.6383 15.4478 12.4293 15.5355 12.2108 15.5374C11.9923 15.5393 11.7818 15.4553 11.6247 15.3035L6.91049 10.5893Z"
//                     fill="white"
//                 />
//             </g>
//             <defs>
//                 <clipPath id="clip0_1822_4745">
//                     <rect width="20" height="20" fill="white" />
//                 </clipPath>
//             </defs>
//         </svg>
//     );
// }
